import { FC } from 'react';
import { TableListQueryResponse } from '../../../_core/interfaces/table-list-query.interface';
import { EngagementDto } from '@families-link/shared';
import { useTranslation } from 'react-i18next';
import { useReactTable, getCoreRowModel } from '@tanstack/react-table';
import { CoreTable, CoreTableEmptyBody } from '../../../_core/components/_ui/core-table';
import { ImportedWarningsColumnName, useImportedWarningsTableColumns } from '../../hooks/imported-warnings-table-columns.hook';

export interface ImportedWarningsTableHandlers {
	onEdit?(dto: any): void;
}

type ImportedWarningsTableProps = TableListQueryResponse<EngagementDto> & ImportedWarningsTableHandlers & {importedWarningsColumnsList: ImportedWarningsColumnName[]};

export const ImportedWarningsTable: FC<ImportedWarningsTableProps> = (props) => {
	const {
		data,
		sorting,
		onSortingChange,
		loading,
		hasMore,
		fetchMore,
		scrollRef,
		onEdit,
		importedWarningsColumnsList
	} = props;

	const [t] = useTranslation();

	const columns = useImportedWarningsTableColumns(
		{
			onEdit,
		},
		importedWarningsColumnsList,
	);

	const table = useReactTable<any>({
		data,
		columns,
		state: {
			sorting,
		},
		onSortingChange,
		getCoreRowModel: getCoreRowModel(),
	});

	return (
		<CoreTable
			px={0}
			ref={scrollRef}
			loading={loading}
			hasMore={hasMore}
			threshold={200}
			emptyListComponent={<CoreTableEmptyBody description={t('engagements.no-engagements')} />}
			fetchMore={fetchMore}
			rowModel={table.getRowModel()}
			headerGroups={table.getHeaderGroups()}
		/>
	);
};
